import './App.css';
import React, { useState, useEffect } from 'react';
import EmainNav from './components/navbars/EmainNav';
import EnavbarPhone from './components/navbars/EnavbarPhone';
import { EaboutABP } from './components/sections/english/Eabout';
import { EclientsABP } from './components/sections/english/Eclients';
import { Efooter } from './components/misc/Efooter';
import { Egallery } from './components/sections/english/Egallery';
import { EsecondGallery } from './components/sections/english/Esecond-gallery';
import { EavailableWorks } from './components/sections/english/EavailableWorks';
import { EthirdGallery } from './components/sections/english/EthirdGallery';
import { Eproviders } from './components/sections/english/Eproviders';
function Eapp() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <main>
      <header id='beginning'>
        {isMobile ? (
          <EnavbarPhone></EnavbarPhone>
        ) :
          (
            <EmainNav></EmainNav>
          )}
        <h1>ANFRO</h1>
      </header>
      <section id='about'>
        <EaboutABP></EaboutABP>
      </section>
      <section id='gallery'>
        <Egallery></Egallery>
      </section>
      <section id='works'>
        <EavailableWorks></EavailableWorks>
      </section>
      <section id='thirdGallery'>
        <EthirdGallery></EthirdGallery>
      </section>
      <section id='clients'>
        <EclientsABP></EclientsABP>
      </section>
      <section>
        <EsecondGallery></EsecondGallery>
      </section>
      <section>
        <Eproviders></Eproviders>
      </section>
      <section id='footer'>
        <Efooter></Efooter>
      </section>
    </main>
  );
}

export default Eapp;
